export default "__VITE_ASSET__lFgNOo9k__"